<!-- <p class="smart-sec-head chatgpt-style-typing" *ngIf="query && total">
  <img class="banner-icon" src="https://res.cloudinary.com/afterbricks/image/upload/v1725704017/icons/circle_ul862h.png" alt="">
  <span class="typed-text-wrapper">
    <span class="typed-text" [innerHTML]="displayText"></span>
  </span>
</p> -->

<p class="smart-sec-head chatgpt-style-typing" *ngIf="query && total">
  <!-- <img class="banner-icon" src="https://res.cloudinary.com/afterbricks/image/upload/v1725704017/icons/circle_ul862h.png" alt=""> -->
  <span class="typed-text" #typedText></span>
</p>